@for(ticket of tickets; track ticket.id){
  <div class="support-request" (click)="ticketClicked.emit(ticket)" [class.active]="(generalSrv?.activeTicket | async)?.ticket == ticket && !resizeManager.isPortrait">
    <h4>Ticket-Anfrage</h4>
    <h3>{{ticket.description}}</h3>
    <div class="support-request-customer-name">{{ticket.addressSearchText}}</div>

    <!-- <div class="actions">
      <afs-button cursor="default" size="small" type="outline" color="danger" (click)="rejectRequest($event, ticket)">Anfrage ablehnen</afs-button>
      <afs-button cursor="default" size="small" type="outline" color="white" (click)="acceptRequest($event, ticket)">Akzeptieren & Zuweisen</afs-button>
    </div> -->
  </div>
}
